import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "antd";
import { UnlockOutlined } from "@ant-design/icons";

const RequestAccessToServiceCollectionButton = ({
  serviceCollection,
  eligibilitySettings,
  disabled,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const clear = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    clear();
  };

  const handleOk = async () => {
    setIsModalOpen(false);
  };

  let snowUrl = undefined;
  if (
    eligibilitySettings &&
    eligibilitySettings.eligibilityApprovalProcedureUrl
  ) {
    snowUrl = eligibilitySettings.eligibilityApprovalProcedureUrl;
  } else {
    const snowAddress = "https://cern.service-now.com/service-portal";
    const snowSe = "se=SSO-Service";
    const snowDescription = `Requesting access to Services ${serviceCollection.serviceCollection.displayName}`;
    let snowComments =
      "Please get agreement from my guarantor (or supervisor) then add my account to one of these groups:\r\n";
    if (eligibilitySettings && eligibilitySettings.approvedEligibilityGroupId)
      snowComments +=
        "https://groups-portal.web.cern.ch/group/" +
        eligibilitySettings.approvedEligibilityGroupId +
        "/details\r\n";

    snowUrl = `${snowAddress}?id=sc_cat_item&name=request&${snowSe}&short_description=${encodeURI(
      snowDescription,
    )}&comments=${encodeURI(snowComments)}`;
  }

  return (
    <>
      <Button
        disabled={disabled}
        icon={<UnlockOutlined />}
        type="text"
        size="middle"
        onClick={openModal}
      >
        Request
      </Button>
      <Modal
        title={
          "Requesting access to " +
          serviceCollection.serviceCollection.displayName
        }
        open={isModalOpen}
        onCancel={handleCancel}
        onClose={handleCancel}
        onOk={handleOk}
      >
        <p>A guarantor needs to validate your eligibility to these services.</p>
        <p>
          <a href={snowUrl} target="_blank" rel="noopener noreferrer">
            Please click here to open a SNOW ticket to make the request.
          </a>
        </p>
      </Modal>
    </>
  );
};

RequestAccessToServiceCollectionButton.propTypes = {
  serviceCollection: PropTypes.object.isRequired,
  eligibilitySettings: PropTypes.object,
  disabled: PropTypes.bool,
};

export default RequestAccessToServiceCollectionButton;
